import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { apiFetch } from '../services/api';

interface FirebaseWebConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

let authPromise: Promise<ReturnType<typeof getAuth>> | undefined;

export const getFirebaseAuth = (): Promise<ReturnType<typeof getAuth>> => {
  if (!authPromise) {
    authPromise = apiFetch<{ data: FirebaseWebConfig }>('/config/firebase')
      .then(({ data }) => {
        if (Object.values(data).some((value) => !value)) {
          throw new Error('Google sign-in is not configured.');
        }
        const app = getApps().length ? getApp() : initializeApp(data);
        return getAuth(app);
      })
      .catch((error) => {
        authPromise = undefined;
        throw error;
      });
  }
  return authPromise;
};

export const createGoogleProvider = (): GoogleAuthProvider => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  return provider;
};
